import { memo, useCallback, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import SelectListItemWithDetails, {
  ListItemWithDetails,
  TagItem,
} from "@coworker/apprestructured/src/task-management/components/SelectListItemWithDetails/SelectListItemWithDetails";

const items: ListItemWithDetails[] = [
  {
    value: "physical_damage",
    label: "Physical damage",
    tags: [
      { value: "scratches", label: "Scratches" },
      { value: "dents", label: "Dents" },
      { value: "broken_parts", label: "Broken parts" },
      { value: "discolouration", label: "Discolouration" },
    ],
  },
  {
    value: "missing_parts",
    label: "Missing parts",
    tags: [
      { value: "screws", label: "Screws / fixings" },
      { value: "instructions", label: "Assembly instructions" },
      { value: "accessories", label: "Accessories" },
    ],
  },
  {
    value: "assembly_issue",
    label: "Assembly issue",
    tags: [
      { value: "wrong_fit", label: "Parts do not fit" },
      { value: "unclear_instructions", label: "Unclear instructions" },
    ],
  },
  {
    value: "other",
    label: "Other",
    tags: [],
  },
];

type SelectedValue = {
  value: string;
  label: string;
  description: string;
  tags: TagItem[];
};

function SelectWithDescriptionAndTagsDemo() {
  const [storedValue, setStoredValue] = useState<SelectedValue>({
    value: "",
    label: "",
    description: "",
    tags: [] as TagItem[],
  });
  const [disabled, setDisabled] = useState(false);
  const [title, setTitle] = useState("Describe the problem");

  const handleConfirmClick = useCallback((selected: SelectedValue) => {
    setStoredValue(selected);
  }, []);

  return (
    <Demo>
      <Name>SelectListItemWithDetails</Name>
      <Highlight>
        <FixaListView id="select-with-description-and-tags-demo" size="small">
          <SelectListItemWithDetails
            title={title}
            value={storedValue.value}
            label={storedValue.label}
            description={storedValue.description}
            selectedTags={storedValue.tags}
            listItems={items}
            onConfirmClick={handleConfirmClick}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="select-with-description-and-tags-disabled"
          id="select-with-description-and-tags-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaInputField
          id="select-with-description-and-tags-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
      </Actions>
    </Demo>
  );
}

export default memo(SelectWithDescriptionAndTagsDemo);
